import {Component, Inject, OnInit} from "@angular/core";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {FelloOfferJourneyType} from "fello-model";

@Component({
  selector: "app-why-email-needed",
  templateUrl: "./why-email-needed.component.html",
  styleUrls: ["./why-email-needed.component.scss"]
})
export class WhyEmailNeededComponent implements OnInit {
  journeyType: FelloOfferJourneyType;
  FelloOfferJourneyType = FelloOfferJourneyType;

  constructor(@Inject(MAT_DIALOG_DATA) type: FelloOfferJourneyType) {
    this.journeyType = type;
  }

  ngOnInit(): void {}
}
